import {view} from '@sail/ui';

export const AvatarSpacer = () => <view.div css={{width: '28px'}} />;
